import { QueryParamManager } from '../utils/QueryParamManager';
import { router } from '../utils/router';
export function hotelSRPRoute(isHotelOnly) {
    const newRoute = isHotelOnly ? '/hotels' : '/holidays/hotels';
    const paramManager = new QueryParamManager(newRoute, router.currentParams());
    return [paramManager.toString(), undefined, { shallow: true }];
}
export function hotelSRPRouting(isHotelOnly) {
    router.push(isHotelOnly, hotelSRPRoute);
}
